import { render, staticRenderFns } from "./FlexbenMenu.vue?vue&type=template&id=5603e2bc&scoped=true&"
import script from "./FlexbenMenu.vue?vue&type=script&lang=js&"
export * from "./FlexbenMenu.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=5603e2bc&scoped=true&lang=css&"
import style1 from "./FlexbenMenu.vue?vue&type=style&index=1&id=5603e2bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603e2bc",
  null
  
)

export default component.exports